// GTM Configuration - Global variables
window.GTM_CONFIG = {
  baseUrl: 'https://www.googletagmanager.com',
  containerId: 'GTM-PHKZBX4W'
};